module.exports = "/next-static/_next/static/images/startRecording-80a32a8657a3af99a2088a36004ce36c.png";